const target = document.querySelector(".js-select-action");

if(target) {
  target.addEventListener("change", () => {
    if(target.value == 0) {
      target.classList.remove('-select-value');
    } else {
      target.classList.add('-select-value');
    }
  });
}

